import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuBox from "../../../components/Custom/CustomizedMenuBox";
import { useAuth, usePermission } from "../../../hooks/use-auth";

const InventorySetting = () => {
  const { permissions } = useAuth();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [allPermissionList, setAllPermissionList] = useState([]);

  const isAdmin = "ADMIN__ADMIN__ADMIN";

  useEffect(() => {
    setAllPermissionList(permissions);
  }, [permissions]);

  const breadcrumbs = [
    {
      name: t("setting.index"),
      to: "/setting",
    },
    {
      name: t("setting.warehouseSetting"),
    },
  ];

  const {
    locationPermission,
    categoryPermission,
    uomPermission,
    attributePermission,
  } = usePermission();

  const menuList = [
    allPermissionList.some((permission) =>
      [locationPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("setting.inventory.location.index"),
      navigateTo: "location",
    },
    allPermissionList.some((permission) =>
      [categoryPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("setting.inventory.category.index"),
      navigateTo: "category",
    },
    // { title: t("setting.inventory.uom.group"), navigateTo: "uomgroup" },
    allPermissionList.some((permission) =>
      [uomPermission.VIEW, isAdmin].includes(permission)
    ) && { title: t("setting.inventory.uom.index"), navigateTo: "uom" },
    allPermissionList.some((permission) =>
      [attributePermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("setting.inventory.attribute.index"),
      navigateTo: "attribute",
    },
  ];

  const formatMenuList = menuList.filter((menu) => menu !== false);

  const renderMenuList = () =>
    formatMenuList.map((menu) => (
      <Grid item xs={12} sm={6} md={3} lg={3} xl={2} key={menu.title}>
        <CustomizedMenuBox
          title={menu.title}
          linkTo={`${pathname}/${menu.navigateTo}`}
          isGridItem
        />
      </Grid>
    ));

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ my: 2 }}>
        <Grid container spacing={1}>
          {renderMenuList()}
        </Grid>
      </Box>
    </>
  );
};

export default InventorySetting;
